/**
 * Web stand-in for @react-native-async-storage/async-storage.
 * Persists to localStorage so auth/session survive page refresh.
 */
const PREFIX = 'budget:as:';

const AsyncStorage = {
  async getItem(key) {
    try {
      return window.localStorage.getItem(PREFIX + key);
    } catch {
      return null;
    }
  },
  async setItem(key, value) {
    window.localStorage.setItem(PREFIX + key, String(value));
  },
  async removeItem(key) {
    window.localStorage.removeItem(PREFIX + key);
  },
  async clear() {
    const toRemove = [];
    for (let i = 0; i < window.localStorage.length; i++) {
      const k = window.localStorage.key(i);
      if (k && k.startsWith(PREFIX)) toRemove.push(k);
    }
    toRemove.forEach((k) => window.localStorage.removeItem(k));
  },
  async multiGet(keys) {
    return Promise.all(keys.map(async (key) => [key, await AsyncStorage.getItem(key)]));
  },
  async multiSet(pairs) {
    await Promise.all(pairs.map(([key, value]) => AsyncStorage.setItem(key, value)));
  },
  async multiRemove(keys) {
    await Promise.all(keys.map((key) => AsyncStorage.removeItem(key)));
  },
  async getAllKeys() {
    const keys = [];
    for (let i = 0; i < window.localStorage.length; i++) {
      const k = window.localStorage.key(i);
      if (k && k.startsWith(PREFIX)) keys.push(k.slice(PREFIX.length));
    }
    return keys;
  },
};

export default AsyncStorage;
